export const profile = {
  Verified: 'Desarrollador verificado',
  'Experience years': '7 años de experiencia',
  'Minutes on spotify': '83.194 minutos en Spotify (2024)',
  'About me': 'Sobre mí',
  'About me description': `🚀 Ingeniero de Software Senior 🚀

👨‍💻 Ingeniero de Software Senior con 7 años de experiencia en desarrollo de aplicaciones web y móviles.

📍 Residenciado en Buenos Aires, Argentina.

💼 Actualmente especializado en proyectos con Typescript, abarcando tanto frontend (React.js) como backend (Node.js), con experiencia en desarrollo móvil (React Native / Ionic / Expo). Además, he trabajado con otros lenguajes de programación como Python y PHP.

⚙️ Apasionado por la automatización y la mejora continua, también tuve la oportunidad de trabajar en tareas DevOps, optimizando procesos y asegurando la eficiencia en el ciclo de vida del desarrollo de software.

🔍 Siempre en búsqueda de nuevos desafíos y oportunidades para aplicar mis habilidades técnicas y pasión por la tecnología en entornos dinámicos y colaborativos.
    `,
  'Download CV': 'Descargar CV',
};
